/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getPODAttachmentBuckets } from "api/services/shipment";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

type GetPODAttachmentBucketsOptions = {
  filters: any;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetPODAttachmentBuckets = (data: GetPODAttachmentBucketsOptions) =>
  useQuery({
    queryKey: shipmentQueryKeys.podAttachmentBucketList(data.filters),
    queryFn: data.queryFn
      ? data.queryFn
      : ({ signal }) =>
          getPODAttachmentBuckets({ params: data.filters, signal })
            .then((res) => res.data)
            .catch((err) => err),
    ...data.options,
  });
